module.exports = __webpack_public_path__ + "img/111007.9bde82b9.png";